import React from "react";
import { HiRefresh } from "react-icons/hi";
import { IoReload } from "react-icons/io5";
import { Link } from "react-router-dom";

const currentYear = new Date().getFullYear();
export default function Footer() {
  return (
    <React.Fragment>
      <div className=" footer">
        <div className="somelinks">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <ul>
                  <li>
                    <Link to={"/privacypolicy"}>Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to={"/termsconditions"}>Terms &amp; Conditions</Link>
                  </li>
                </ul>
                <div className="clearfix" />
              </div>
            </div>
          </div>
        </div>

        <div className="somelinks2">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center copyright">
                ©️{currentYear} A7-Sattakingg All Rights Reserved
              </div>
            </div>
          </div>
        </div>
        <section className="somelinks">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <ul>
                  <li>
                    <a className="text-center" href="#">
                      <strong>
                        !! DISCLAIMER:- A-7 Sattakingg is a non-commercial
                        website. Viewing This Website Is Your Own Risk, All The
                        Information Shown On Website Is Sponsored And We Warn
                        You That Matka Gambling/Satta May Be Banned Or Illegal
                        In Your Country..., We Are Not Responsible For Any
                        Issues Or Scam..., We Respect All Country Rules/Laws...
                        If You Not Agree With Our Site Disclaimer... Please Quit
                        Our Site Right Now. Thank You.
                      </strong>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="icon-bar">
        <div
          className="d-flex align-items-center"
          onClick={() => window.location.reload()}
        >
          <span>Refresh</span>
          <a className="facebook fs-2">
            <HiRefresh />
          </a>
        </div>
      </div>
    </React.Fragment>
  );
}
